import { Link } from 'react-router-dom';

/**
 * AuthShell — armazón de las pantallas de autenticación (identidad v2.1).
 * Móvil/tablet: isotipo [O] CODE sobre la placa de concreto y el formulario debajo.
 * Escritorio: panel izquierdo con atleta (mismo tratamiento que la landing: luminosidad,
 * fundido al asfalto, placa y corchetes) y "Todo en tu mano" con los tres pilares;
 * a la derecha, el isotipo y el formulario.
 */
const PILLARS = [
  ['Tu progreso', 'Peso, medidas, récords y gráficas que se mueven contigo.'],
  ['Tus rutinas', 'Un plan para tu deporte, tu lugar y tus días. Lo decides tú.'],
  ['Tu salud', 'Evaluación, alimentación a tu gusto y seguimiento. Sobre todo, eso.'],
];

const ATHLETE = 'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?auto=format&fit=crop&w=1400&q=70';

const Isotype = ({ size = 168, className = '' }) => (
  <div
    className={`relative overflow-hidden onor-rise onor-breathe ${className}`}
    style={{ width: size, height: size, borderRadius: Math.round(size * 0.18), boxShadow: 'inset 0 1px 0 rgba(229,233,240,.1), 0 20px 40px rgba(0,0,0,.6)', animationDelay: '.1s, 1.2s' }}
  >
    <img src="/brand/app-icon-square.webp" alt="ONOR CODE" width={size} height={size} draggable="false" className="w-full h-full object-cover" />
    <i className="onor-glint" aria-hidden="true" />
    <i className="corner corner-tl" aria-hidden="true" />
    <i className="corner corner-br" aria-hidden="true" />
  </div>
);

const AuthShell = ({ children, footer = true }) => (
  <div className="relative min-h-screen bg-zinc-950 lg:grid lg:grid-cols-[1.05fr_.95fr]">
    <div aria-hidden="true" className="plate-bg" />

    {/* Panel de atleta (solo escritorio) */}
    <aside className="hidden lg:flex relative z-10 flex-col justify-end overflow-hidden border-r border-zinc-800" aria-hidden="true">
      <div
        className="absolute inset-[-6%_0] bg-cover bg-[center_25%] opacity-40 onor-kb"
        style={{ backgroundImage: `url('${ATHLETE}')`, mixBlendMode: 'luminosity' }}
      />
      <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(11,12,14,.55) 0%, rgba(11,12,14,.25) 35%, rgba(11,12,14,.75) 70%, #0B0C0E 100%)' }} />
      <div className="absolute inset-0" style={{ background: 'linear-gradient(90deg, transparent 70%, #0B0C0E 100%)' }} />
      <div className="plate-bg" />
      <i className="corner corner-tl" style={{ top: 24, left: 24, width: 32, height: 32 }} />
      <i className="corner corner-br" style={{ bottom: 24, right: 24, width: 32, height: 32 }} />
      <div className="relative p-16 pb-20 max-w-xl onor-rise" style={{ animationDelay: '.2s' }}>
        <p className="font-display font-semibold uppercase tracking-[.2em] text-xs text-zinc-400 mb-4">Honor · Disciplina · <span className="text-bronze">Fuerza</span></p>
        <h2 className="font-display font-bold uppercase text-6xl leading-none mb-8" style={{ background: 'linear-gradient(90deg,#E5E9F0 0%,#969CA8 100%)', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>
          Todo en tu mano.
        </h2>
        <ul className="grid gap-3">
          {PILLARS.map(([t, d], i) => (
            <li key={t} className="grid grid-cols-[132px_1fr] gap-4 items-start px-4 py-3 border border-zinc-700 rounded-sm relief" style={{ background: 'rgba(20,22,25,.85)' }}>
              <b className={`font-display font-bold uppercase text-lg leading-7 ${i === 2 ? 'text-bronze' : 'text-zinc-100'}`}>{t}</b>
              <span className="text-zinc-400 text-sm leading-5">{d}</span>
            </li>
          ))}
        </ul>
      </div>
    </aside>

    {/* Isotipo + formulario */}
    <main className="relative z-10 min-h-screen grid grid-rows-[auto_1fr_auto] px-4 lg:px-12">
      <div className="flex justify-center pt-8 lg:pt-12 pb-2"><Isotype size={168} className="lg:!w-[144px] lg:!h-[144px]" /></div>
      <div className="flex flex-col justify-center w-full max-w-md mx-auto py-4 gap-4">{children}</div>
      {footer && (
        <div className="flex justify-center gap-4 py-6 text-xs text-zinc-400">
          <Link to="/terminos" className="hover:text-zinc-100">Términos</Link>
          <Link to="/privacidad" className="hover:text-zinc-100">Privacidad</Link>
          <span>© 2026 ONOR CODE</span>
        </div>
      )}
    </main>
  </div>
);

export { Isotype };
export default AuthShell;
